import { render, staticRenderFns } from "./FastAddResearcher.vue?vue&type=template&id=01ee3a3a&"
import script from "./FastAddResearcher.vue?vue&type=script&lang=js&"
export * from "./FastAddResearcher.vue?vue&type=script&lang=js&"
import style0 from "./FastAddResearcher.vue?vue&type=style&index=0&id=01ee3a3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports